{
    "path_url": "/local/templates/main_new/components/bitrix/news.list/credits_main/handler.php"
}